import { render } from "./AncestorTree.vue?vue&type=template&id=15903ff0&scoped=true"
import script from "./AncestorTree.vue?vue&type=script&lang=js"
export * from "./AncestorTree.vue?vue&type=script&lang=js"

import "./AncestorTree.vue?vue&type=style&index=0&id=15903ff0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15903ff0"]])

export default __exports__